import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import Logo from "../../../assets/Images/logo.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllAttendanceSummaryReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearAttendanceSummaryReportList } from "../reportsSlice";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const AttendanceSummaryReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("attendancesummaryreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
  @page {
    margin-left: 0.5cm;
    margin-right: 0.5cm;
  }
  @page landscapePage {
    size: landscape;
  }
  .salesmanwisereport-print-break {
    page: landscapePage;
    page-break-before: always;
  }
}
    `;
    document.head.appendChild(style);
  };

  const AttendanceSummaryReportList = useAppSelector(
    (state) => state.reports.AttendanceSummaryReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      sr_id: state?.sr_id,
      from_date: state?.from_date,
      to_date: state?.to_date,
    };
    const res = await dispatch(getAllAttendanceSummaryReport(payload));
    if (res.meta.requestStatus === "fulfilled") {
      setPrintStyles();
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("attendancesummaryreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearAttendanceSummaryReportList());
    };
  }, []);

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {AttendanceSummaryReportList && AttendanceSummaryReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 20,
                        top: 20,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "10px", marginBottom: "10px" }}
                    >
                      <tr>
                        <td
                          rowSpan={3}
                          style={{
                            width: "200px",
                            border: "1px solid lightgray",
                          }}
                        >
                          <div style={{ height: "100px" }}>
                            <img
                              src={`${Logo}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          HARIHAR FOODS PVT LTD.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>
                            Attendance Summary Report{" "}
                          </h6>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid lightgray",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            For Period :{" "}
                            {state.from_date &&
                              state.to_date &&
                              `( ${moment(state.from_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} )`}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print`}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          {checkInclude("sr_name", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>
                              Sales Representative
                            </th>
                          )}
                          {checkInclude("visit_date", formRenderProps) && (
                            <th>Attendance Date</th>
                          )}
                          {checkInclude("market_in_time", formRenderProps) && (
                            <th>Market in Time</th>
                          )}
                          {checkInclude("market_out_time", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>Market out Time</th>
                          )}
                          {checkInclude("start_time", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>
                              Distributor in Time
                            </th>
                          )}
                          {checkInclude("end_time", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>
                              Distributor out Time
                            </th>
                          )}
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {AttendanceSummaryReportList.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                {checkInclude("sr_name", formRenderProps) && (
                                  <td>{item?.sr_name}</td>
                                )}
                                {checkInclude(
                                  "visit_date",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {item?.visit_date
                                      ? moment(
                                          item?.visit_date,
                                          "DD/MM/YYYY"
                                        ).format("DD-MMM-YYYY")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude(
                                  "market_in_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {item?.market_in_time
                                      ? moment(
                                          item?.market_in_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude(
                                  "market_out_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {" "}
                                    {item?.market_out_time
                                      ? moment(
                                          item?.market_out_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}{" "}
                                  </td>
                                )}
                                {checkInclude(
                                  "start_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {" "}
                                    {item?.start_time
                                      ? moment(
                                          item?.start_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude("end_time", formRenderProps) && (
                                  <td>
                                    {" "}
                                    {item?.end_time
                                      ? moment(
                                          item?.end_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default AttendanceSummaryReport;
